export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name':
    'Pixartprinting S.p.A., sociedad unipersonal, una empresa Cimpress. Todos los derechos reservados',
  'privacy-policy': 'Política de privacidad',
  'cookie-policy': 'Política de cookies',
  'informazioni-legali': 'Información legal',
}
